var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "SortView", class: _vm.modes.map((m) => `SortView--${m}`) },
    [
      _c(
        "div",
        { staticClass: "SortViewButton" },
        [_c("svg-view", { attrs: { name: "sort" } })],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }